import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";
import { QuestionSectionWrapper } from "@/components/features/items/edit/_shared/ui/components/system/question/_layouts/item-wrapper";

import { InputNumberField } from "@/components/ui/form/fields/input-field/input-number";

import { useReservationDefaultInitPeopleNum } from "./hooks/use-default-init-people-num";

export const QuestionReservationDefaultInitPeopleNum = () => {
	const { isEdited, hasError, defaultInitPeopleNum, onSetDefaultInitPeopleNum } =
		useReservationDefaultInitPeopleNum();

	const title = "初期表示の人数";
	const guide =
		"ゲストが予約ページを見た時、カレンダーに表示される料金の人数・予約人数の初期値を設定できます。 <br />できるだけ多くの在庫が表示できる人数に設定しましょう。";

	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title={title}
			isEdited={isEdited}
			hasError={hasError}
			guide={guide}
			inputChildren={
				<QuestionSectionWrapper>
					<p>初期表示の人数</p>
					<InputNumberField
						value={defaultInitPeopleNum.value}
						handleInput={onSetDefaultInitPeopleNum}
						errorMessage={defaultInitPeopleNum.error}
						hiddenSpinButton={false}
					/>
					<p>人</p>
				</QuestionSectionWrapper>
			}
		/>
	);
};

QuestionReservationDefaultInitPeopleNum.displayName = "QuestionReservationDefaultInitPeopleNum";
